import { createContext, ReactNode, useContext } from "react";

type Context = {
  canAdd: boolean;
  addendums: ParsedNoteAddendum[];
  addendum: Record<string, string>;
  setAddendum?: (arg: Record<string, string>) => void;
};
const AddendumsContext = createContext<Context>({
  canAdd: false,
  addendums: [],
  addendum: {},
  setAddendum: () => null,
});

type Props = {
  canAdd: boolean;
  addendums: ParsedNoteAddendum[];
  addendum?: Record<string, string>;
  setAddendum?: (arg: Record<string, string>) => void;
  children: ReactNode;
};

export const AddendumsContextProvider = ({
  addendums,
  addendum,
  setAddendum,
  canAdd,
  children,
}: Props) => (
  <AddendumsContext.Provider
    value={{
      addendums,
      addendum: addendum || {},
      setAddendum,
      canAdd,
    }}
  >
    {children}
  </AddendumsContext.Provider>
);

export const useAddendums = () => useContext(AddendumsContext);
